import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import transactionApi from "./apiTransaction.js";

const initialState = {
  transactions: [],
  transaction: null,
  credit: null,
  isError: false,
  isLoading: false,
  errorMessage: "",
};

// create transaction
export const createTransaction = createAsyncThunk(
  "transaction/createTransaction",
  async (transaction, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await transactionApi.createTransaction(token, transaction);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);

// get transaction
export const getTransaction = createAsyncThunk(
  "transaction/getTransaction",
  async (data, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await transactionApi.getTransaction(token, data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);

export const createBookingDeposit = createAsyncThunk(
  "transaction/createBookingDeposit",
  async (data, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await transactionApi.createBookingDeposit(token, data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);

// get all transactions
export const getTransactions = createAsyncThunk(
  "transaction/getTransactions",
  async (query, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await transactionApi.getTransactions(token, query);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);

export const getAgentsCredit = createAsyncThunk(
  "transaction/getAgentsCredit",
  async (_, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await transactionApi.getAgentsCredit(token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);

export const getTransactionAnalytics = createAsyncThunk(
  "transaction/getTransactionAnalytics",
  async (query, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await transactionApi.getTransactionAnalytics(token, query);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    resetTransaction: (state, action) => {
      state.transaction = null;
      state.isError = false;
      state.isLoading = false;
      state.errorMessage = "";
      state.transactions = [];
      state.credit = null;
    },
  },
  extraReducers: {
    // create transaction
    [createTransaction.pending]: (state, action) => {
      state.isLoading = true;
    },
    [createTransaction.fulfilled]: (state, action) => {
      window.location.reload();
      state.isLoading = false;
      // state.transaction = action.payload;
    },
    [createTransaction.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
    },
    // get transaction
    [getTransaction.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getTransaction.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.transaction = action.payload.data;
    },
    [getTransaction.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
    },
    // get all transactions
    [getTransactions.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getTransactions.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.transactions = action.payload;
    },
    [getTransactions.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
    },
    // get transaction analytics
    [getTransactionAnalytics.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getTransactionAnalytics.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.transactionAnalytics = action.payload;
    },
    [getTransactionAnalytics.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
    },

    [getAgentsCredit.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getAgentsCredit.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.credit = action.payload.data;
    },
    [getAgentsCredit.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
    },
  },
});

export const { resetTransaction } = transactionSlice.actions;
export default transactionSlice.reducer;
